module.exports = __webpack_public_path__ + "static/media/united_card_1.f6c78964.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/images/united_card_1.jpg
// module id = 522
// module chunks = 0